var _path, _path2, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEndtoend(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 111,
    height: 106,
    viewBox: "0 0 111 106",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M110.94 90.5883C110.256 83.2352 104.092 77.7204 96.8189 77.7204C89.9 77.7204 84.02 82.7167 82.8628 89.5041H29.1165C19.5764 89.5041 11.8071 82.104 11.8071 73.0067C11.8071 63.9095 19.5762 56.5093 29.1165 56.5093H84.2088C96.3702 56.5093 106.241 46.9881 106.241 35.2985C106.241 23.6088 96.3467 14.0876 84.2088 14.0876H45.8355L55.9661 3.97709C56.8634 3.03431 56.8399 1.54955 55.9189 0.654057C54.998 -0.218019 53.5574 -0.218019 52.6365 0.654057L38.4678 14.7946C37.5469 15.7138 37.5469 17.1985 38.4678 18.1177L52.6365 32.2582C53.5811 33.1537 55.0688 33.1303 55.9661 32.2112C56.8399 31.292 56.8399 29.8543 55.9661 28.9352L45.8355 18.8011H84.2088C93.749 18.8011 101.518 26.2012 101.518 35.2985C101.518 44.3957 93.7492 51.7959 84.2088 51.7959H29.1165C16.9552 51.7959 7.0843 61.3171 7.0843 73.0067C7.0843 84.6963 16.9787 94.2176 29.1165 94.2176H82.8628C84.1852 102.066 91.7654 107.298 99.6527 105.719C106.69 104.305 111.602 97.7293 110.94 90.5883ZM96.8189 101.264C91.6002 101.264 87.3731 97.0459 87.3731 91.8373C87.3731 86.629 91.6 82.4102 96.8189 82.4102C102.038 82.4102 106.265 86.629 106.265 91.8373C106.265 97.0457 102.038 101.264 96.8189 101.264Z",
    fill: "url(#paint0_linear_289_973)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M28.3373 16.4211C28.3373 8.62017 21.9851 2.28056 14.1686 2.28056C6.3522 2.28056 0 8.62017 0 16.4211C0 24.2221 6.3522 30.5617 14.1686 30.5617C21.9851 30.5617 28.3136 24.2455 28.3373 16.4211ZM4.72281 16.4211C4.72281 11.2128 8.94971 6.99401 14.1686 6.99401C19.3873 6.99401 23.6145 11.2125 23.6145 16.4211C23.6145 21.6295 19.3876 25.8483 14.1686 25.8483C8.94993 25.848 4.72281 21.6295 4.72281 16.4211Z",
    fill: "url(#paint1_linear_289_973)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_289_973",
    x1: 3.90217,
    y1: 10.3695,
    x2: 124.251,
    y2: 106.232,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D65B03"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF6B00"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_289_973",
    x1: 3.90217,
    y1: 10.3695,
    x2: 124.251,
    y2: 106.232,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D65B03"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF6B00"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEndtoend);
export default __webpack_public_path__ + "static/media/endtoend.0022420e9e670917bfc5925754f33111.svg";
export { ForwardRef as ReactComponent };